export const STUDIO_NAVIGATION_REQUEST_EVENT = 'studio:navigation-request'

export type StudioNavigationRequestDetail = {
  navigate: () => void
}

export function requestStudioNavigation(navigate: () => void) {
  const request = new CustomEvent<StudioNavigationRequestDetail>(STUDIO_NAVIGATION_REQUEST_EVENT, {
    cancelable: true,
    detail: { navigate },
  })

  if (window.dispatchEvent(request)) navigate()
}
